import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/**
 * Ámbar solar es el color de acción de la página (texto azul noche encima,
 * contraste ~8:1). Rojo stop queda reservado para riesgo y FAIL.
 */
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-4 text-[17px] sm:text-xl rounded-2xl min-h-[60px]' : 'px-5 py-3 text-sm rounded-xl';
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-2 text-center bg-ember hover:bg-ember-hover text-pine font-bold tracking-wide shadow-card hover:shadow-lift transition-all duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-paper/70 ${sizing} ${className}`} data-id="element-78" data-mp="lkxtwl4irwrb">
      {children}
    </a>;
}